import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Guard from 'components/Guard'
import Login from 'sections/auth/Login'
import Redirect from 'components/Redirect'
import Main from 'sections/Main'
import Settings from 'sections/Settings'
import Tracks from 'sections/Tracks'
import Info from 'sections/Info'
import Statistics from 'sections/Statistics'
import StatisticsDistance from 'sections/Statistics/Distance'
import StatisticsSpeed from 'sections/Statistics/Speed'
import Events from 'sections/Events'
import Layout from 'sections/Layout'

const Ro = () => {

  console.log( 'Router' )

  return <BrowserRouter>
    <Routes>
      <Route path="/" Component={ Guard }>
        <Route path="main" Component={ Main } />

        <Route path="settings" Component={ Settings } />

        <Route path="tracks" Component={ Tracks } />

        <Route path="statistics" Component={ Statistics }>
          <Route path="distance" Component={ StatisticsDistance } />

          <Route path="speed" Component={ StatisticsSpeed } />

          <Route
            index
            element={ <Redirect to="/statistics/distance" /> }
          />

          <Route
            path="*"
            element={ <Redirect to="/statistics/distance" /> }
          />
        </Route>

        <Route path="events" Component={ Events } />

        <Route path="layout" Component={ Layout } />

        <Route
          index
          element={ <Redirect to="/main" /> }
        />

        <Route
          path="*"
          element={ <Redirect to="/main" /> }
        />
      </Route>

      <Route path="/info" Component={ Info } />

      <Route path="/auth/login" Component={ Login } />
    </Routes>
  </BrowserRouter>
}

export default Ro
